var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"flex-start flex-grow"},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view',{staticClass:"flex-grow"})],1),_c('shopping-cart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }